export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 p-8 md:p-12 rounded-2xl bg-gradient-to-br from-background-50 via-background-100 to-background-50 border border-background-300/30">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/15 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-400"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100 mb-3">移动端便捷访问</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5">
              在线吃瓜已针对移动端进行全面适配优化。无论使用手机浏览器还是微信内置浏览器，均可获得流畅的浏览体验。
              无需下载任何APP，打开浏览器输入在线吃瓜最新入口地址即可随时访问。页面加载速度、排版布局、图片展示均经过专项优化，
              流量消耗更低，触屏操作更便捷。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200 px-3 py-1.5 rounded-lg">
                <i className="ri-check-line text-green-400"></i> 免下载安装
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200 px-3 py-1.5 rounded-lg">
                <i className="ri-check-line text-green-400"></i> 流量节省优化
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200 px-3 py-1.5 rounded-lg">
                <i className="ri-check-line text-green-400"></i> 全平台兼容
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}